import React from 'react';
import Icon from './SvgIcon';

class ProgressSvg extends React.Component {
  constructor(props) {
    super(props);

  }
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.NowProgress !== nextProps.NowProgress) {
      return true;
    }
    return false;
  }
  render() {
   return (
     <div className="Navigation-progress">
       <svg width="64" height="64" viewBox="0 0 120 120">
         <circle cx="60" cy="60" r={this.props.circleRadius} fill="none" stroke="#000"  strokeWidth="12"/>
         <circle cx="60" cy="60" r={this.props.circleRadius} fill="none" stroke="#069AFF" strokeWidth="8" strokeDasharray={this.props.circleR}
           strokeDashoffset={this.props.NowProgress} />
         <text textAnchor="middle" transform="rotate(90,60,60)" fill="#fff" x="60" y="50">{this.props.restNum > 0 ? "残り":　"学習"}</text>
         <text fontSize="22px" transform="rotate(90,60,60)" textAnchor="middle" fill="#fff" x="60" y="80">{this.props.restNum === 0 ? "修了": this.props.restNum}</text>
       </svg>
     </div>
   );
  }
}

export default ProgressSvg;



// WEBPACK FOOTER //
// ./src/ProgressSvg.js